import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useContext, useRef } from 'react';
import SvgCamera from '../../../../__generated__/icon/SvgCamera';
import { CustomEditorContext } from '..';
type ResultUrl = Promise<string | void | undefined | null> | string | void | undefined | null;
export interface ImageButtonProps {
  onClick?: () => ResultUrl;
  limit?: number;
  onLimitExceed?: () => void;
  className?: string;
  iconClassName?: string;
  self?: boolean;
  onChange?: (file?: File) => ResultUrl;
}

/**
 * 에디터 툴바의 이미지 추가 버튼
 */
export const ImageButton = t0 => {
  const $ = _c(25);
  const {
    className,
    iconClassName,
    limit,
    onClick,
    onLimitExceed,
    self,
    onChange
  } = t0;
  const inputFileRef = useRef(null);
  const {
    editor
  } = useContext(CustomEditorContext);
  let t1;
  if ($[0] !== editor || $[1] !== limit || $[2] !== onLimitExceed) {
    t1 = async url => {
      if (!editor) {
        throw new Error("ImageButton\uC740 CustomEditorProvider \uB0B4\uBD80\uC5D0\uC11C\uB9CC \uC0AC\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
      }
      if (limit) {
        const imageList = [];
        editor.state.doc.content.forEach(content => {
          if (content.type.name === "image") {
            imageList.push(content.attrs.src);
          }
        });
        if (limit <= imageList.length) {
          onLimitExceed?.();
          return;
        }
      }
      if (!url) {
        return;
      }
      const from = editor.state.selection.from;
      const marks = editor.state.doc.resolve(from).marks();
      const currentNode = editor.state.doc.nodeAt(from);
      const href = currentNode?.attrs?.href;
      let chainedCommand = editor.chain().focus().insertContent([{
        type: "image",
        attrs: {
          src: url,
          href
        }
      }, {
        type: "paragraph",
        content: ""
      }]);
      marks.forEach(mark => {
        chainedCommand = chainedCommand.setMark(mark.type, mark.attrs);
      });
      chainedCommand.run();
    };
    $[0] = editor;
    $[1] = limit;
    $[2] = onLimitExceed;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const insertImage = t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("inline-flex size-fit items-center justify-center rounded-xxsmall transition-colors hover:bg-Gray-100 active:bg-Gray-200", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== insertImage || $[7] !== onClick || $[8] !== self) {
    t3 = async e => {
      e.preventDefault();
      if (self) {
        inputFileRef.current?.click();
        return;
      }
      const url_0 = await onClick?.();
      insertImage(url_0);
    };
    $[6] = insertImage;
    $[7] = onClick;
    $[8] = self;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== iconClassName) {
    t4 = cn("size-20 text-Gray-900", iconClassName);
    $[10] = iconClassName;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <SvgCamera className={t4} name="Camera" />;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t5) {
    t6 = <button aria-label={"\uC774\uBBF8\uC9C0 \uC0BD\uC785"} className={t2} type="button" onClick={t3}>{t5}</button>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "none"
    };
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== insertImage || $[20] !== onChange) {
    t8 = <input ref={inputFileRef} type="file" accept="image/*" style={t7} onChange={async event => {
      const file = event.target.files?.[0];
      const url_1 = await onChange?.(file);
      insertImage(url_1);
    }} />;
    $[19] = insertImage;
    $[20] = onChange;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t8) {
    t9 = <div className="inline-flex">{t6}{t8}</div>;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};